import {
  ADD_TO_FAVORITES,
  REMOVE_FROM_FAVORITES,
  RECEIVE_FAVORITES
} from '../actions/FavoritesActions';


const processFavorites = items => {
  return items.map(item => {

    // unwrap the array
    if (item.product_album.length) {
      item.product_album = item.product_album[0];
    }

    return item;
  });
};

export function FavoritesReducer(state = { items: [] }, action) {
  switch (action.type) {
    case ADD_TO_FAVORITES: {
      return {
        isFetching: true,
        didInvalidate: false,
        items: [...state.items, action.item]
      }
    }
    case REMOVE_FROM_FAVORITES: {
      return {
        isFetching: true,
        didInvalidate: false,
        items: state.items.filter( (item) => item.id !== action.item)
      }
    }
    case RECEIVE_FAVORITES: {
      const items = processFavorites(action.items);

      return {
        isFetching: false,
        didInvalidate: false,
        items: [...state.items, ...items]
      }
    }
    default: {
      return state;
    }
  }
}


// WEBPACK FOOTER //
// ./src/reducers/FavoritesReducer.js